/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced analytics, AI-powered simulations, and real-time insights to build the perfect F1 Fantasy team.`)
};

const es_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis avanzados, simulaciones impulsadas por IA e insights en tiempo real para construir el equipo F1 Fantasy perfecto.`)
};

const de_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortgeschrittene Analysen, KI-gestützte Simulationen und Echtzeit-Einblicke für das perfekte F1 Fantasy Team.`)
};

const nl_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geavanceerde analyses, AI-gestuurde simulaties en realtime inzichten om het perfecte F1 Fantasy-team samen te stellen.`)
};

const fr_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses avancées, simulations propulsées par IA et insights en temps réel pour construire l’équipe F1 Fantasy parfaite.`)
};

const it_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi avanzate, simulazioni AI e insight in tempo reale per costruire il team F1 Fantasy perfetto.`)
};

const pt_br2_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análises avançadas, simulações com IA e insights em tempo real para montar a equipe F1 Fantasy perfeita.`)
};

const pt_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análises avançadas, simulações com IA e insights em tempo real para construir a equipa F1 Fantasy perfeita.`)
};

const ja_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高度な分析、AIシミュレーション、リアルタイムの洞察で完璧なF1ファンタジーチームを構築。`)
};

const zh_f1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先进分析、AI驱动模拟和实时洞察，助您打造完美的F1梦幻车队。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_hero_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_hero_subtitle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_hero_subtitle", locale)
	if (locale === "en") return en_f1_home_hero_subtitle(inputs)
	if (locale === "es") return es_f1_home_hero_subtitle(inputs)
	if (locale === "de") return de_f1_home_hero_subtitle(inputs)
	if (locale === "nl") return nl_f1_home_hero_subtitle(inputs)
	if (locale === "fr") return fr_f1_home_hero_subtitle(inputs)
	if (locale === "it") return it_f1_home_hero_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_hero_subtitle(inputs)
	if (locale === "pt") return pt_f1_home_hero_subtitle(inputs)
	if (locale === "ja") return ja_f1_home_hero_subtitle(inputs)
	return zh_f1_home_hero_subtitle(inputs)
};